import React from 'react';



function useConnectedSwipers(defaultSlide, sharedParams, sections) {
	const [swiperController, setSwiperController] = React.useState(null);
	const [focusedSlide, setFocusedSlide] = React.useState(defaultSlide);

	const initialState = {};

	sections.forEach((section) => {
		initialState[section] = null;
	});

	const [swipers, setSwipers] = React.useState(initialState);

	const getSwiperParams = (name) => {
		const setSwiper = (value) => {
			setSwipers((swipers) => {
				return {
					...swipers,
					[name]: value,
				};
			});
		};

		const params = Object.assign({}, sharedParams, {
			onSwiper: setSwiper,
			onTouchEnd: () => {
				setSwiperController(null);
			},
			onTouchStart: () => {
				setSwiperController(name);
			},
		});

		return params;
	};

	React.useEffect(
		() => {
			if (swiperController) {
				const swiper = swipers[swiperController];

				if (swiper !== null && swiper !== null && swiper.controller) {
					const currentSwiper = swiper;

					const listOfAllOtherSwipers = Object.values(swipers).filter((swiper) => {
						return swiper !== currentSwiper;
					});

					currentSwiper.controller.control = listOfAllOtherSwipers;

					for (const otherSwiper of listOfAllOtherSwipers) {
						otherSwiper.controller.control = undefined;
					}
				}
			}

			if (focusedSlide !== defaultSlide) {
				Object.keys(swipers).forEach((swiper) => {
					if (swiper !== null) {
						swipers[swiper].slideTo(defaultSlide);
					}
				});

				setFocusedSlide(defaultSlide);
			}
		},
		[
			defaultSlide,
			focusedSlide,
			swiperController,
			swipers,
		],
	);

	return {
		getSwiperParams,
	};
}



export default useConnectedSwipers;
